import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { GoogleIcon } from 'src/components/icons';
import Button from 'src/legacy/components/Button';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import * as Colors from 'src/theme/colors';

export interface GoogleAuthButtonStyleProps {
  noBorderRadius?: boolean;
}

const useStyles = makeStyles<GoogleAuthButtonStyleProps>()((theme, props) => ({
  root: {
    border: `1px solid ${Colors.NonHoverBorder}`,
    color: theme.palette.text.primary,
    height: 48,
    borderRadius: props.noBorderRadius ? 0 : theme.shape.borderRadius,
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  icon: {
    height: 16,
    width: 16,
  },
}));

export interface GoogleAuthButtonProps extends GoogleAuthButtonStyleProps {
  onClick?: () => void;
}

export const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({
  onClick,
  noBorderRadius,
}) => {
  const { classes } = useStyles({ noBorderRadius });
  return (
    <Button
      fullWidth
      htmlId="googleSignIn"
      startIcon={<GoogleIcon className={classes.icon} />}
      onClick={onClick}
      color="inherit"
      className={clsx(classes.root)}
      size="large"
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    >
      <BaseTypography fontType="15Medium">Continue with Google</BaseTypography>
    </Button>
  );
};
